














export default {
  name: 'MenuOpenIcon',
  props: {
    small:Boolean,
    alt:Boolean
  }

};
